// extracted by mini-css-extract-plugin
export var container = "_a5-0";
export var containerTopRight = "_a5-1";